/*=========================================================================================
  File Name: module-notification-mutations.js
  Description: Notification Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	NotificationList: [],
	hasNewNotify: false,
	countNew: 0
};
